module.exports = __webpack_public_path__ + "img/google-signin.cefb6f63.svg";